import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-roman" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
      return (_openBlock(), _createElementBlock("div", { key: key }, [
        (error.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(error[0]), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}